import LocalMap from './LocalMap';

export default LocalMap; 